import { Color, Group, Path, Segment } from "paper/dist/paper-core";

export default class Beard extends Group {
  constructor() {
    const beardClippingPath = new Path({
      segments: [
        [50, 51],
        [50 + 6, 52],
        [50 + 4, 55],
        [50, 55],
        [50 - 4, 55],
        [50 - 6, 52],
      ],
      closed: true,
    });

    beardClippingPath.smooth({ type: "catmull-rom" });

    const beard = new Path({
      segments: [
        [50 - 15, 32],
        new Segment({
          point: [50 - 10, 50],
          handleIn: [-5, -5],
        }),
        new Segment({
          point: [50, 48],
          handleIn: [-5, 0],
          handleOut: [5, 0],
        }),
        new Segment({
          point: [50 + 10, 50],
          handleOut: [5, -5],
        }),
        [50 + 15, 32],
        [50 + 16, 32],
        new Segment({
          point: [50 + 15, 55],
          handleIn: [2, -10],
          handleOut: [0, 5],
        }),
        new Segment({
          point: [50, 65],
          handleIn: [5, 0],
          handleOut: [-5, 0],
        }),
        new Segment({
          point: [50 - 15, 55],
          handleIn: [2, 5],
          handleOut: [-2, -2],
        }),
        [50 - 16, 32],
      ],
    }).exclude(beardClippingPath);

    beard.fillColor = new Color("#2d415e");
    beard.strokeColor = new Color("#2d415e");
    beard.strokeWidth = 1;

    super([beard, beardClippingPath]);
  }
}
